export enum LoadingStatusErrorCode {
    notFound = 404,
    badRequest = 400
}
